// extracted by mini-css-extract-plugin
export default {"content":"AboutUsPopup_content__DVTLh","text":"AboutUsPopup_text__r0ZY+","logo":"AboutUsPopup_logo__XltT8"};